import { useTheme } from "@mui/material";
import { useTranslation } from "../../hooks/useTranslation";
import { CopyableChipView } from "./components/CopyableChipView";
import { CopyableTextView } from "./components/CopyableTextView";
import { useCopyableState } from "./components/utils/useCopyableState";
import { CopyableVariant } from "./components/utils/copyable.utils";

interface Props {
  initialLabel: string;
  variant?: CopyableVariant;
  maxWidth?: number;
  size?: "small" | "medium";
}

export const Copyable = ({
  initialLabel,
  variant = "chip",
  maxWidth = 180,
  size = "small",
}: Props) => {
  const theme = useTheme();
  const { translateWithoutPrefix } = useTranslation("");

  const state = useCopyableState(initialLabel);

  if (variant === "text") {
    return (
      <CopyableTextView
        initialLabel={initialLabel}
        maxWidth={maxWidth}
        state={state}
        theme={theme}
        t={translateWithoutPrefix}
      />
    );
  }

  return (
    <CopyableChipView
      initialLabel={initialLabel}
      size={size}
      state={state}
      theme={theme}
      t={translateWithoutPrefix}
    />
  );
};
